import React from 'react';
import { Tabs, Background, Logo, Copyright, Download } from '../../Component';
import styles from './index.module.less';

const Horizontal = () => {
  return (
    <div className={styles.login}>
      <div className={styles.left} style={{ flex: 3 }}>
        <Background className={styles.background} />
        <div className={styles.footer}>
          <Copyright />
        </div>
      </div>
      <div className={styles.right} style={{ flex: 2 }}>
        <Logo className={styles.logo} />
        <Tabs className={styles.tabs} mode="horizon" />
        <Download className={styles.download} />
      </div>
    </div>
  );
};

export default Horizontal;
